module.exports = __webpack_public_path__ + "static/media/ms.87247c34.png";